export default __webpack_public_path__ + "static/Live_Cams_02-fb35f3bd0417cb92a049ef716d7a8bd8.webp";